export default __webpack_public_path__ + "static/media/hht2_ep10_book_wp_02.0506e184.jpg";